import PatientCard from "../Components/PatientCard";
import { useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import { setPatients } from "../redux/slice/patientSlice";
import { useAuth } from "../context/AuthContext";
import useApi from "../customHooks/useAPI";
import useProfile from "../customHooks/useProfile";

const MyPatient = () => {
    const dispatch = useDispatch();
    const { doctorId } = useAuth();
    const [mypatients, setMypatients] = useState([]);
    const [filteredPatients, setFilteredPatients] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");
    const { callApi: callDoctorApi } = useApi();
    const { callApi: callNotesApi } = useApi();
    const {checkProfileStatus} = useProfile();

    const fetchData = async () => {
        try {
            const [patientsData, notesData] = await Promise.all([
                callDoctorApi({
                    url: `${process.env.REACT_APP_BACKEND_ENDPOINT}/doctor/myPatients`,
                    headers: { 
                        "doctor-id": doctorId 
                    }
                }),
                callNotesApi({
                    url:`${process.env.REACT_APP_BACKEND_ENDPOINT}/doctor/allPatientNotes`, 
                    headers: { "doctor-id": doctorId }
                })
            ]);

            const mergedPatients = patientsData.data.map(patient => {
                const notesForPatient = notesData.data
                    ?.filter(note => note.patientId === patient.id)
                    ?.map(note => note.note) || "";
                return { ...patient, note: notesForPatient[0] };
            });

            setMypatients(mergedPatients);
            setFilteredPatients(mergedPatients);
            dispatch(setPatients(mergedPatients));
        } catch (error) {
            console.error(error);
        }
    };

    const handleSearch = (value) => {
        setSearchQuery(value);

        const filtered = mypatients.filter((p) => {
            const fullName = `${p.first_name} ${p.last_name}`.toLowerCase();
            return (
                fullName.includes(value.toLowerCase()) ||
                p.id.toString().includes(value)
            );
        });

        setFilteredPatients(filtered);
    };

    useEffect(() => {
        checkProfileStatus();
        if (doctorId) {
            fetchData();
        }
    }, [doctorId]);

    return (
        <div className="min-h-screen bg-gradient-to-t from-green-50 to-blue-50 p-6">
            {/* Header */}
            <div className="max-w-6xl mx-auto flex flex-col sm:flex-row justify-between items-center mb-6 gap-4">
                <h1 className="text-3xl font-bold text-gray-800">My Patients</h1>

                {/* Search Bar */}
                <input
                    type="text"
                    value={searchQuery}
                    onChange={(e) => handleSearch(e.target.value)}
                    placeholder="Search by name or patient ID..."
                    className="w-full sm:w-72 px-4 py-2 rounded-xl border border-gray-300 shadow-sm focus:ring-2 focus:ring-blue-400 focus:outline-none"
                />
            </div>

            {/* Patients Grid */}
            <div className="max-w-6xl mx-auto grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
                {filteredPatients.length > 0 ? (
                    filteredPatients.map((item) => (
                        <PatientCard key={item.id} patientInfo={item} />
                    ))
                ) : (
                    <div className="w-full col-span-full text-center text-gray-500">
                        No matching patients found.
                    </div>
                )}
            </div>
        </div>
    );
};

export default MyPatient;
